module.exports = __webpack_public_path__ + "img/logo.7704c7f5.png";